// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-login-form-___login-form__form___Mm6D0 {
  width: 24em;
}

.src-components-login-form-___login-form__title___j4Rlr {
  margin: 0 0 1em;
}

.src-components-login-form-___login-form__group___PUNgg {
  display: inline-block;
  font-weight: 700;
  margin-bottom: 1em;
  width: 100%;
}

.src-components-login-form-___login-form__footer___HiaZ5 {
  text-align: right;
}

/* .input copied and modified from Bootstrap's .form-control */
.src-components-login-form-___login-form__input___hfsnF {
  display: block;
  width: 100%;
  height: 2.5em;
  padding: 0.5em 1em;
  font-size: 14px;
  line-height: 1.42857143;
  color: var(--gray);
  background-color: #fff;
  background-image: none;
  border: 1px solid var(--default-border);
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.src-components-login-form-___login-form__input___hfsnF:focus {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.src-components-login-form-___login-form__input___hfsnF[disabled],
.src-components-login-form-___login-form__input___hfsnF[readonly],
fieldset[disabled] .src-components-login-form-___login-form__input___hfsnF {
  background-color: var(--gray-lighter);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/login-form/login-form.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;EAClB,gDAAgD;EAChD,sEAAsE;AACxE;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,8EAA8E;AAChF;;AAEA;;;EAGE,qCAAqC;EACrC,UAAU;AACZ","sourcesContent":[".form {\n  width: 24em;\n}\n\n.title {\n  margin: 0 0 1em;\n}\n\n.group {\n  display: inline-block;\n  font-weight: 700;\n  margin-bottom: 1em;\n  width: 100%;\n}\n\n.footer {\n  text-align: right;\n}\n\n/* .input copied and modified from Bootstrap's .form-control */\n.input {\n  display: block;\n  width: 100%;\n  height: 2.5em;\n  padding: 0.5em 1em;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: var(--gray);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid var(--default-border);\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.input:focus {\n  border-color: #66afe9;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n\n.input[disabled],\n.input[readonly],\nfieldset[disabled] .input {\n  background-color: var(--gray-lighter);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `src-components-login-form-___login-form__form___Mm6D0`,
	"title": `src-components-login-form-___login-form__title___j4Rlr`,
	"group": `src-components-login-form-___login-form__group___PUNgg`,
	"footer": `src-components-login-form-___login-form__footer___HiaZ5`,
	"input": `src-components-login-form-___login-form__input___hfsnF`
};
export default ___CSS_LOADER_EXPORT___;
